import React from "react";

const Third = ({ msg, color }) => {
  return (
    <>
      <ul class="list-disc pl-4 md:p-10 space-y-3 text-gray-500 mt-2">
        <li>
          Chama chochote kitakachofanya mabadiliko ya jina, anwani, madhumuni au
          kifungu chochote cha Katiba yake kitatakiwa kupata idhini kwa kupeleka
          maombi kwa Msajili kupitia Msajili Msaidizi kwa kujaza fomu za maombi
          Na. BMT 6,7, 8 na 9 kulingana na marekebisho yatakayofanyika. Baada ya
          Msajili kufanyia kazi maombi hayo, atawajulisha wahusika kwa maandishi
          kuhusu kukubaliwa au kukataliwa kwao katika kipindi cha siku 14 tangu
          kupokelewa maombi yao;
        </li>
        <li>
          Msajili anaweza kuyakataa maombi ya Chama kubadili jina lake ikiwa:-
          <ul
            role="list"
            class="list-decimal pl-5 space-y-3 text-gray-500 mt-2"
          >
            <li>
              Jina jipya linafanana na jina la Chama kingine kilichosajiliwa
              mahali popote hapa nchini.
            </li>
            <li>
              Jina jipya linakaribia kufanana na chama kingine chochote kiasi
              kwamba linawezakuleta utata miongoni mwa jamii nzima au wananchama
              wenyewe;
            </li>
            <li>Anaona kuwa jina hilo halifai;</li>
            <li>Kwa maelekezo ya Waziri.</li>
            <br />
          </ul>
          <li>
            Msajili anaweza akayakataa maombi yoyote ya kubadili kifungu
            chochote cha Katiba ya Chama au Kanuni za Chama ikiwa:-
            <ul
              role="list"
              class="list-decimal pl-5 space-y-3 text-gray-500 mt-2"
            >
              <li>
                Anaona kuwa mabadiliko hayoyanaweza kuhatarisha usalama na
                kuvuruga amani miongoni mwa wanachama na jamii kwa ujumla na
                hivyo kuathiri maendeleo ya chama;
              </li>
              <li>
                Atabaini kuwa mabadiliko hayo yanalenga kuwanufaisha wachache;
              </li>
              <li>
                Anaona kuwa mabadiliko hayo yatakifanya chama kuingilia shughuli
                za Chama kingine na kuathiri utekelezaji wa shughuli za Chama
                hicho kingine;
              </li>
              <li>
                Anaona kuwa mabadiliko hayo hayafai kwa kuwa hayazingatii Sera
                ya Michezo, Sera ya Utamaduni na Sheria ya Baraza la Michezo la
                Taifa;
              </li>
              <li>Kwa maelekezo ya Waziri;</li>
              <br />
            </ul>
          </li>
          <li>
            Endapo Msajili atakataa maombi yoyote ya kubadili kifungu chochote
            cha Katiba ya Chama aawajulisha wahusika kwa kutumia fomu Na. BMT.
            10.
          </li>
          <li>
            Endapo Msajili ataafiki mabadiliko yaliyofanyika atatoa idhini kwa
            chama kutumia fomu Na. BMT. 11.
          </li>
          <li>
            Baada ya kupokea taarifa ya kukatalia maombi yao, Chama hicho
            kinaruhusiwa kukara rufaa kwa Waziri katika kipindi cha siku 21
            kuanzia tarehe ya kukataliwa;
          </li>
          <li>Uamuzi wowote utakaotolewa na Waziri utakuwa wa mwisho;</li>
          <li>
            Msajili ataingiza taarifa yoyote ya marekebisho katika vitabu vya
            kumbukumbu kwa kadri atakavyoipokea kwa mujibu wa kanuni hizi;
          </li>
          <li>
            Msajili atatoa hati mpya ya usajili kwa chama chochote
            kilichokubaliwa kubadilisha jina baada ya Chama hicho kurejesha hati
            yake ya mwanzo.
          </li>
        </li>
      </ul>
    </>
  );
};

export default Third;
